import { createReducer, on } from '@ngrx/store';
import { Agreement } from '@models/agreement.model';
import { AgreementActions } from '@store/actions/agreement/agreement.actions';
import { UploadDocumentResponse } from '@models/upload-document-response';
import { DocusignActions } from '@store/actions/docusign/docusign.actions';

export const agreementFeatureKey = 'agreement';

export interface State {
  agreements: Agreement[];
  loadingAgreements: boolean;
  agreementError: string | null;
  agreementForm: any;
  agreementEmail: string;
  showAgreementTable: boolean;
  searchYear: any;
  loadingDocusignCreate: any;
  loadingDocusignView: any;
  docuSignLoading: boolean;
  selectedDocumentFile: File | null;
  uploadProgress: number | null;
  isDocumentUploading: boolean;
  uploadComplete: boolean;
  uploadError: string | null;
  uploadedDocuments: UploadDocumentResponse[];
  loadingDocuments: boolean;
  documentsError: string | null;
  documentUploadProgress: any;
  documentUploading: any;
  documentUploadComplete: any;
  documentUploadError: any;
  documentUploadResponse: any;
  isVoidingAgreement: boolean;
}

export const initialState: State = {
  agreements: [],
  loadingAgreements: false,
  agreementError: null,
  agreementForm: null,
  agreementEmail: '',
  showAgreementTable: false,
  searchYear: new Date().getFullYear(),
  loadingDocusignCreate: undefined,
  loadingDocusignView: undefined,
  docuSignLoading: false,
  selectedDocumentFile: null,
  uploadProgress: null,
  isDocumentUploading: false,
  uploadComplete: false,
  uploadError: null,
  uploadedDocuments: [],
  loadingDocuments: false,
  documentsError: null,
  documentUploadProgress: undefined,
  documentUploading: undefined,
  documentUploadComplete: undefined,
  documentUploadError: undefined,
  documentUploadResponse: undefined,
  isVoidingAgreement: false
};

export const reducer = createReducer(
  initialState,
  on(AgreementActions.loadAgreements, (state) => ({
    ...state,
    loadingAgreements: true,
    agreementError: null
  })),
  on(AgreementActions.getAgreementsSuccess, (state, { agreements }) => ({
    ...state,
    agreements,
    loadingAgreements: false,
    agreementError: null
  })),
  on(AgreementActions.getAgreementsFailure, (state, { error }) => ({
    ...state,
    loadingAgreements: false,
    agreementError: error
  })),
  on(AgreementActions.searchYearChanged, (state, { year }) => ({
    ...state,
    searchYear: year
  })),
  on(AgreementActions.selectDocumentFile, (state, { file }) => ({
    ...state,
    selectedDocumentFile: file,
    uploadError: null,
    uploadComplete: false
  })),
  on(AgreementActions.clearSelectedDocumentFile, (state) => ({
    ...state,
    selectedDocumentFile: null,
    uploadProgress: null,
    uploadError: null,
    uploadComplete: false
  })),
  on(AgreementActions.uploadDocument, (state) => ({
    ...state,
    isDocumentUploading: true,
    uploadProgress: 0,
    uploadError: null,
    uploadComplete: false
  })),
  on(AgreementActions.documentUploadProgress, (state, { progress }) => ({
    ...state,
    uploadProgress: progress
  })),
  on(AgreementActions.documentUploadSuccess, (state, { response }) => ({
    ...state,
    isDocumentUploading: false,
    uploadProgress: 100,
    uploadComplete: true,
    uploadError: null,
    selectedDocumentFile: null,
    uploadedDocuments: [response, ...state.uploadedDocuments]
  })),
  on(AgreementActions.documentUploadFailure, (state, { error }) => ({
    ...state,
    isDocumentUploading: false,
    uploadProgress: null,
    uploadComplete: false,
    uploadError: error
  })),
  on(AgreementActions.loadDocuments, (state) => ({
    ...state,
    loadingDocuments: true,
    documentsError: null
  })),
  on(AgreementActions.loadDocumentsSuccess, (state, { documents }) => ({
    ...state,
    uploadedDocuments: documents,
    loadingDocuments: false,
    documentsError: null
  })),
  on(AgreementActions.loadDocumentsFailure, (state, { error }) => ({
    ...state,
    loadingDocuments: false,
    documentsError: error
  })),
  on(AgreementActions.downloadDocument, (state) => ({
    ...state,
  })),
  on(AgreementActions.downloadDocumentSuccess, (state) => ({
    ...state,
  })),
  on(AgreementActions.downloadDocumentFailure, (state, { error }) => ({
    ...state,
    documentsError: error
  })),
  on(AgreementActions.clearDocumentUploadState, (state) => ({
    ...state,
    selectedDocumentFile: null,
    uploadProgress: null,
    isDocumentUploading: false,
    uploadComplete: false,
    uploadError: null
  })),
  on(AgreementActions.voidOrgAgreement, (state) => ({
    ...state,
    isVoidingAgreement: true
  })),
  on(AgreementActions.voidOrgAgreementSuccess, AgreementActions.voidOrgAgreementFailure, (state) => ({
    ...state,
    isVoidingAgreement: false
  }))
);
